import { Route } from "react-router-dom";
import lazyRoute from "@/router/lazy-route";

const FinancialLayout = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/financial/FinancialLayout")
);
const PatientBalance = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientBalance")
);
const PatientBills = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientBills")
);
const PatientCardDetails = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientCardDetails")
);
const PatientClaims = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientClaims")
);
const PatientEraEob = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientEraEob")
);
const PatientInsurancePayment = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientInsurancePayment")
);
const PatientLedger = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientLedger")
);
const PatientPaymentsNew = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientPaymentsNew")
);
const PatientReadyForBilling = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/financial/PatientReadyForBilling")
);

export const PatientChartFinancialRoutes = () => (
  <Route path="financial" element={<FinancialLayout />}>
    <Route index element={<PatientBills />} />
    <Route path={"ready-for-billing"} element={<PatientReadyForBilling />} />
    <Route path={"claims"} element={<PatientClaims />} />
    <Route path={"era-eob"} element={<PatientEraEob />} />
    <Route path={"payments"} element={<PatientPaymentsNew />} />
    <Route path={"insurance-payment"} element={<PatientInsurancePayment />} />
    <Route path={"patientbalance"} element={<PatientBalance />} />
    <Route path={"carddetails"} element={<PatientCardDetails />} />
    <Route path={"ledger"} element={<PatientLedger />} />
  </Route>
);
